import NoticeApprovalList from "src/pages/NoticeApproval/NoticeApprovalList";

export const noticeApprovalRoutes = [
  { path: '/notice-approval', component: NoticeApprovalList },
];
